<template>
  <div class="shipper-info">
    <loading v-if="loading"></loading>
    <div class="header">
        <div class="layout-wrapper">
            <header id="page-topbar">
                <BaseButton variant="secondary" @click="$router.push({path: '/partners', hash: '#second'})">Quay lại</BaseButton>
            <div class="title">
                <p>Thông tin shipper</p>
            </div>
                <el-button type="danger" plain @click="delShipperModal = true">Xóa shipper</el-button>
            </header>
        </div>

        <div class="boxContent boxContentExt" style="margin-top:110px">      
            <div class="__card first-box">
                <div class="cards-header">
                    <LayoutCardTitle>Thông tin shipper</LayoutCardTitle>
                    <el-button @click="() => this.$router.push(`/orders-delivery/edit-shipper/${this.id}`)">Chỉnh sửa</el-button>
                </div>
                <el-form label-width="170px" style="width:100%">
                    <el-row>
                        <el-col>
                            <el-form-item label="Họ và tên" class="mb-0">
                                <span>{{name}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="Số điện thoại" class="mb-0">
                                <span>{{phoneNo}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="Địa chỉ" class="mb-0">
                                <span>{{address}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="Ghi chú" class="mb-0">
                                <span>{{note}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>            
            </div>
        </div>

        <div class="boxContent boxContentExt">      
            <div class="__card first-box">
                <LayoutCardTitle style="padding: 12px">Lịch sử giao hàng</LayoutCardTitle>
                <el-form label-width="170px" style="width:100%">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="Tổng số đơn hàng" class="mb-0">
                                <span>{{numSuccessOrders || 0}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Tổng phí giao hàng" class="mb-0">
                                <span>{{totalPaidAmount || 0}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div style="max-width: 100%; width: 100%">
                    <b-table :items="dataItems" :fields="fieldTable">
                        <template #table-caption>
                            <div v-if="dataItems.length === 0">
                                <div class="text-center mt-5 mb-5 empty-return-table">
                                    <p>Bạn chưa có đơn giao hàng nào</p>
                                </div>
                            </div>
                        </template>
                        <template #cell(orderNo)="data">
                            <span 
                                @click="() =>$router.push({ path: `/orders-delivery/delivery-order-detail/${data.item.id}`})"
                                style="cursor: pointer; color:#3E69F6">
                                    {{data.item.orderNo}}
                            </span>
                        </template>
                        <template #cell(partnerShippingFee)="data">
                            {{ formatMoneyNotUnit(data.item.partnerShippingFee) }}
                        </template>
                        <template #cell(checkoutAt)="data">
                            {{ data.item.checkoutAt }}
                        </template>
                        <template #cell(processorStatusText)="data">
                            <base-tag v-if="data.item.processorStatusDisplay && data.item.processorStatusDisplay.color" :type="data.item.processorStatusDisplay.color">{{ data.item.processorStatusDisplay.text }}</base-tag> 
                        </template>
                    </b-table>
                </div>
            </div>
        </div>

        <el-dialog title="Xóa tài khoản" :visible.sync="delShipperModal" width="600px" :close-on-click-modal="false" append-to-body>
            <div class="text-center">
                <div class="modal-img"><img src="@/assets/shipper-icons/shipper-del.png" /></div>
                <p>Bạn chắc chắn muốn xoá thông tin shipper “{{name}}”?</p>
                <p>Thao tác này không thể khôi phục</p>
            </div>
            <template slot="footer">
                <el-button class="esc-btn" type="text" @click="delShipperModal = false">Thoát</el-button>
                <el-button
                    type="primary"
                    @click="deleteShipper"
                >
                    Xác nhận xóa
                </el-button>
            </template>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import { ShipperServices } from '@/services/nextshop/shipper.service'
import { OrdersService } from "@/services/nextshop/orders.service"
import { OrderDeliveryStatus } from "../../utils/mapping";
import { formatHHmmDDMMYYYY } from "../../utils/format";
export default {
    data() {
        return {
            loading: false,
            id: this.$route.params.id,
            inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
            name: '',
            phoneNo: '',
            note: '',
            address: '',
            numSuccessOrders: '',
            totalPaidAmount: '',
            orders: 0,
            fieldTable: [
                {
                    label: "Mã đơn giao",
                    key: "orderNo",
                },
                {
                    label: "Mã đơn hàng",
                    key: "soOrderNo",
                },
                {
                    label: "Người nhận",
                    key: "customerName",
                },
                {
                    label: "Trạng thái",
                    key: "processorStatusText",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: "Ngày giao",
                    key: "checkoutAt",
                },
                {
                    label: "Phí trả ĐTGH",
                    key: "partnerShippingFee",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],
            dataItems: [],
            delShipperModal: false,
        }
    },

    created() {
        this.getShipperById();
        this.getShipperOrderReport();
    },

    methods: {
        async getShipperById() {
            this.loading = true;
            let param = {
                partnerId: this.id,
                merchantId: this.inforAccount.merchantId,
            }
            try {
                const res = await ShipperServices.getShipperById(param)
                if (res.success) {
                    this.name = res.data.name;
                    this.phoneNo = res.data.phoneNo;
                    this.address = res.data.address ? res.data.address : '--';
                    this.note = res.data.note ? res.data.note : '--'
                }
            } finally {
                this.loading = false
            }
        },

        async getShipperOrderReport() {
            let param = {
                queryString: `{orderType} == '''DLO''' and {furtherInstructions.params.shipperId} == '''${this.id}'''`,
                sort: "DESC",
                sortBy : "createdAt",
                pageSize: 10,
                pageNum: 1
            }
            try {
                const res = await OrdersService.getShipperOrderReport(param)
                if (res.success) {
                    res.data.orders.map((item) => {
                        const { partyB, furtherInstructions } = item;
                        const tmp =  {
                            ...item,
                            orderNo : item.orderNo, //Mã đơn giao
                            soOrderNo: furtherInstructions[0].params.soOrderNo, //Mã đơn hàng
                            customerName: partyB.displayName, // người nhận
                            createdAt: formatHHmmDDMMYYYY(item.createdAt),
                            partnerShippingFee: item.lineItemFinalizing.finalAmount / 1000, //Phí trả ĐTGH
                            checkoutAt: furtherInstructions[0].params != undefined ? formatHHmmDDMMYYYY(furtherInstructions[0].params.checkoutAt) : "", //TG xuất kho
                            processorStatusDisplay : item.processorStatus ? OrderDeliveryStatus(item.processorStatus) : null,
                            processorStatusText : item.processorStatus ? OrderDeliveryStatus(item.processorStatus).text : "",
                        };
                        this.dataItems.push(tmp)
                    });
                    this.orders = res.data.orders.length;
                    this.totalPaidAmount = res.data.totalPaidAmount ? this.formatMoney(this.divisionThousand(res.data.totalPaidAmount)) : '--';
                    this.numSuccessOrders = res.data.numSuccessOrders ? res.data.numSuccessOrders : '0';
                }
            } finally {

            }
        },

        async deleteShipper() {
            this.loading = true;
            const param = {
                partnerIds: [this.id],
                merchantId: this.inforAccount.merchantId,
            }

            try {
                const res = await ShipperServices.deleteShipper(param)
                if (res.success) {
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: '<h4 style="color:#67c23a">Xóa shipper thành công</h4><p style="color:#23313E">Tài khoản shipper đã xóa</p>',
                        type: 'success'
                    });
                    this.$router.push({path: '/partners', hash: '#second'})
                }
            } finally {

            }
        }
    }
}
</script>


<style lang="scss" scoped>

.boxContent .__card {
  max-width: 960px;
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 70%;
}

.cards-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 12px;
}
</style>
